<template>

          <!-- :remote-method="getData" -->
    
        <Select v-if="isMultiple == 1" v-model="hasChecked"
            filterable
            remote
            :clearable="clearable"
            :loading="loading"
            @on-change="setVal"
            @on-clear="getData"
            multiple
            :placeholder='placeholderText'
    >
        <Option v-for="(item) in dataList"  :label="item[labelName]" :value="item[valName]" :key="item.id" style='display:flex;align-items: center;justify-content: space-between;'><span>{{ item[labelName] }}</span>  <span v-if="labelNameNew">{{ item[labelNameNew] }}</span></Option>
    </Select>

  <Select v-else-if='isMultiple == 2'
          v-model="hasChecked"
          filterable
          remote
          :clearable="clearable"
          :loading="loading"
          @on-clear="getData"
           :placeholder='placeholderText'
          @on-change="setVal"
  >
    <Option v-for="(item) in dataList" :label="item[labelName]" :value="item[valName]" :key="item.id" style='display:flex;align-items: center;justify-content: space-between;'><span>{{ item[labelName] }}</span> <span v-if="labelNameNew">{{ item[labelNameNew] }}</span></Option>
  </Select>

  <Select v-else-if='isMultiple == 3'
          v-model="hasChecked"
          filterable
          remote
          :clearable="clearable"
          :loading="loading"
          @on-change="setVal"
          @on-clear="getData"
        :placeholder='placeholderText'
  >
    <Option v-for="(item,index) in dataList" :value="item" :key="index" style='display:flex;align-items: center;justify-content: space-between;'>{{ item }}</Option>
  </Select>
  

</template>
<script>
    import common from '@/common/common.js';

    export default {
        name: "selectList",
        components: {
        },
        model:{
            prop: 'checkVal',
            event: 'change'
        },
        props: {
            checked: Boolean,

            url: String,//接口的链接
            valName: String,//传入后台的值
            labelName: String,//对外显示的说明
            isMultiple:{ //是否多选  1  多选 2单选 3 单选 直接数据
                type: [Number,String],
                default: 2
            },
            keyword: { //搜索词的字段名
                type: String,
                default: ''
            },
            labelNameNew: { //备注字段
                type: String,
                default: ''
            },
            clearable:{//是否可清空
                type: Boolean,
                default: true
            },
            checkedList:{//选中的值 多选时传入数组
                type: String|Array,
                default: ''
            },
            placeholderText:{
                type:[String,Number],
                default:'请输入'
            },
            index:{//操作对应的索引
                type: Number,
                default: 0
            },
            checkVal:{ //默认赋值
                type: [Number,String,Array],
                default: ''
            },
            searchKey:{
                type: [Array,Object]
            }
        },
        data() {
            return {
                loading:false,
                dataList:[],
                hasChecked: this.checkVal
            }
        },

        created() {
            this.getData()
        },
        mounted() {
            this.$nextTick(() => {
                if(this.checkedList.length >0){
                    this.hasChecked = this.checkedList
                }
            })
        },
        destroyed() {
        },
        watch:{
            checkVal(val){
                this.hasChecked = val
            },
            hasChecked(val){
                this.hasChecked = val
            }
        },
        methods: {
            getData(query){//获取列表信息
                let params = {}
                params[this.keyword] = query

                if(this.searchKey){
                   this.searchKey.map((item,index)=>{
                        params[item.key] = item.val
                    }) 
                }
                

                let getData = {
                    params:params
                }
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;

                    this.axios.get(this.url,getData).then((result) => {
                        //处理数组
                        if(result.data.code == 1){
                            if(this.isMultiple == 3){
                                this.dataList = result.data.data
                            }else{
                                this.dataList = result.data.data.list != undefined?result.data.data.list:result.data.data
                            }
                        }else{
                            common.msg('error',result.data.message,()=>{})
                        }
                    }).catch((err) => {
                        common.msg('error','获取失败',()=>{})
                    });

                }, 200);
            },
            setDefVal(val){//设置默认值
                this.hasChecked = val
            },
            setVal(data){
                let nowData = ''
                
                if(this.isMultiple == 1){
                    nowData = []
                    this.dataList.forEach((item)=>{
                        data.map((item2,index2)=>{
                            if(item[this.valName] == item2){
                               nowData.push(item)
                            }
                        })
                    })
                }else{
                    this.dataList.forEach((item)=>{
                        if(item[this.valName] == data){
                            nowData = item
                        }
                    })
                }
                this.$emit('setSelected', {nameVal:data,nowData:nowData})
                this.$emit('change', this.hasChecked)
            },
            clearVal(){
              this.hasChecked = []
            },
        }
    }
</script>
<style scoped>

  .feedbackText {
    font-size: 10px;
  }
</style>
